<template>
  <div>
    <b-overlay
      :show="spinner"
      spinner-variant="primary"
    >
      <b-card>
        <proveedoresForm
          :proveedor="proveedorData"
          proveedorSubmit="Crear Proveedor"
          @processProveedor="agregarProveedor"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>

import { BCard, BOverlay } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const proveedoresForm = () => import('@/layouts/components/Proveedores/ProveedoresForm.vue')

export default {
  components: {
    BCard,
    BOverlay,
    proveedoresForm,
  },
  data() {
    return {
      spinner: false,
      proveedorData: {
        rut: '',
        direccion: '',
        razonSocial: '',
        nombre: '',
        telefono: '',
        correo: null,
        estado: null,
      },
    }
  },
  methods: {
    ...mapActions({ createProveedor: 'proveedores/addProveedores' }),
    agregarProveedor(proveedor) {
      this.spinner = true
      this.createProveedor(proveedor).then(() => {
        const errorProveedores = store.state.proveedores
        const errorMessage = errorProveedores.errorMessage.errors
        if (!errorProveedores.error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Proveedor creado con éxito 👍',
              icon: 'CheckIcon',
              text: `El proveedor "${proveedor.nombre}" fue creado con éxito!`,
              variant: 'success',
            },
          },
          {
            timeout: 4000,
          })
          this.$router.replace({
            name: 'proveedores',
          })
        } else if (errorMessage.rut) {
          this.$swal({
            title: 'Error!',
            text: `${errorMessage.rut[0]}!`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        } else {
          this.$swal({
            title: 'Error!',
            text: 'Ingreso de datos fraudulento!',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
        }
        this.spinner = true
      })
    },
  },
}
</script>
